import { isNil } from 'lodash/fp'
import * as v from 'valibot'

import { silentAttempt } from '@masterplandev/utils'

export const validatedLocalStorage = {
  getItem<TSchema extends v.GenericSchema>(
    key: string,
    schema: TSchema,
  ): v.InferOutput<TSchema> {
    const rawItem = silentAttempt(() => localStorage.getItem(key))

    let parsed: unknown
    if (!isNil(rawItem)) {
      try {
        parsed = JSON.parse(rawItem)
      } catch {
        parsed = rawItem
      }
    }

    const { success, output } = v.safeParse(schema, parsed)

    return success ? output : v.getDefault(schema)
  },

  setItem<TSchema extends v.GenericSchema>(
    key: string,
    schema: TSchema,
    value: v.InferInput<TSchema>,
  ) {
    const { success, output } = v.safeParse(schema, value)

    if (success) {
      silentAttempt(() => localStorage.setItem(key, JSON.stringify(output)))
    }
  },

  removeItem(key: string) {
    silentAttempt(() => localStorage.removeItem(key))
  },
}
